import { Address, AddressType } from './Address';

export class Client {
	constructor(){
		this.addresses = [];
	}
	id: number;
	clientName: string;
	cra: boolean;
	clientId : number;
	billingType: ClientBillingTypes;
	directOrder : boolean;
	mainContactName: string;
	mainPhone: string;
	fax: string;
	email: string;
	affiliateName: string;
	knownIntegrations: string;
	rentalUnitCount: number;
	totalPropertyCount: number;
	pms: string;
	ownerName: string;
	ownerCompany: string;
	ownerPhone: string;
	ownerEmail: string;
	billingContact: string;
	billingPhone: string;
	billingEmail: string;
	applicantPayDefault: boolean;
	addresses : Address[] = [];
	
	public get clientPhysicalAddress() : Address {
		let addy = this.addresses.find(a => {return a.physical; });
		return addy; 
	}

	public get clientBillingAddress() : Address {
		let addy = this.addresses.find(a => {return a.billing; });
		return addy; 
	}
	
	isActive : boolean;
	recDecAccept: number;
	recDecConditionalHigh: number;
	recDecConditionalLow: number;
	recDecDeny: number = 0;
	createdDate: Date;
	lastOrdered: Date;
	totalOrders: number;
	prettyCreatedDate: string;
	prettyLastOrderDate : string;
	notes: ClientNote[];
	associatedSalesRep : string;
	accountType : number;
	dba : string;
	packageIds : number[];
}
export class ClientLocation {
	id: number;
	locationName: string;
	clientId: number;
	addressId: number;
	isClientPhysicalAddress: boolean;
	isClientBillingAddress: boolean;
	propertyAccountNumber: string;
	mainContactName: string;
	mainPhone: string;
	fax: string;
	mainContactEmail: string;
	affiliateName: string;
	rentalUnitCount: number;
	ownerName: string;
	ownerCompany: string;
	ownerPhone: string;
	ownerEmail: string;
	billingContact: string;
	billingPhone: string;
	billingEmail: string;
	isActive: boolean;

	addresses : Address[] = [];
	
	public get physicalAddress() : Address {
		let addy = this.addresses.find(a => {return a.physical; });
		return addy; 
	}

	public get billingAddress() : Address {
		let addy = this.addresses.find(a => {return a.billing; });
		return addy; 
	}
	createdDate: Date;
	lastOrdered: Date;
	totalOrders: number;
	prettyCreatedDate: string;
	prettyLastOrderDate : string
	clientName : string;
	dba: string;
	associatedSalesRep: string;
	knownIntegrations: string;
	pms: string;
	recDecAccept: number;
	recDecConditionalHigh: number;
	recDecConditionalLow: number;
	recDecDeny: number = 0;
	notes: PropertyNote[] = [];
}


export enum ClientBillingTypes {
	POS = 0,
	Monthly = 1,
}

export class ClientNote {
	id: number;
	userId: number;
	clientId: number;
	note: string;
	noteType: number;
	createdDate: Date;
	prettyCreatedDate: string;
	creatingUserName: string;
}

export class PropertyNote extends ClientNote {
	locationId : number;
}
export class ClientNoteType {
	constructor(id: number, name : string, cls : string){
		this.id = id;
		this.displayName = name;
		this.className = cls;
	}
	id : number;
	displayName : string;
	className: string;
}


export class UserInvitation {
	constructor(){
		this.properties = new Array<ClientLocation>();
	}
	id: number;
	userId : number;
	firstName: string;
	lastName: string;
	email: string;
	admin: boolean;
	viewBilling: boolean;
	viewReporting: boolean;
	addProperties: boolean;
	addUsers: boolean;
	startScreenings: boolean;
	clientId: number;
	initiatingUserId: number;
	inviteToken: any;
	properties: ClientLocation[];
}
